export enum BasicInputMode {
  DEFAULT = 'default',
  INLINE = 'inline'
}
